import LegalPageShell, { H2, P, UL } from "../../components/LegalPageShell";

export default function Refunds() {
  return (
    <LegalPageShell
      eyebrow="LEGAL · REFUND & CANCELLATION POLICY"
      title="Refund & Cancellation Policy"
      lastUpdated="February 2026"
      testId="refunds-page"
    >
      <P>
        We want Wanted to be a place you choose to be — not one you feel stuck in. This policy explains how
        Premium memberships, cancellations, and refunds work.
      </P>

      <H2>1. Premium Membership</H2>
      <P>
        Premium is a recurring monthly membership currently priced at $24.99 per month (USD). Your
        membership renews automatically each month until you cancel. By starting Premium, you authorize
        Wanted, through our payment processor Stripe, to charge your payment method on a recurring basis.
      </P>

      <H2>2. How to Cancel</H2>
      <P>
        You may cancel your Premium membership at any time from the Membership section of the app, or by
        emailing <a href="mailto:hello@joinwanted.com" className="text-gold hover:text-gold-soft">hello@joinwanted.com</a>.
        Cancellation stops future renewals.
      </P>
      <P>
        When you cancel, you will continue to have access to Premium features through the end of your
        current billing period. After that period, your account reverts to the free membership tier.
        Your matches, messages, and profile remain.
      </P>

      <H2>3. Refunds</H2>
      <P>
        Because Premium is a digital subscription, monthly charges are generally non-refundable. However,
        we want to be fair. We will consider refunds on a case-by-case basis in the following situations:
      </P>
      <UL>
        <li>You were charged in error (for example, after you had already cancelled).</li>
        <li>You experienced a technical issue that prevented you from using Premium for a meaningful portion of your billing period and we were unable to resolve it.</li>
        <li>Your account was closed by us for reasons not related to a violation of our Terms or Community Guidelines.</li>
        <li>A duplicate charge was made.</li>
      </UL>
      <P>
        If you believe one of these applies, email{" "}
        <a href="mailto:hello@joinwanted.com" className="text-gold hover:text-gold-soft">hello@joinwanted.com</a>{" "}
        within 14 days of the charge. Include the email on your account and a short description of what
        happened.
      </P>

      <H2>4. Refunds We Don't Provide</H2>
      <UL>
        <li>Partial refunds for unused days remaining in a billing period after a normal cancellation.</li>
        <li>Refunds where the account was terminated due to a violation of our Terms or Community Guidelines.</li>
        <li>Refunds for charges older than 60 days, except where required by law.</li>
      </UL>

      <H2>5. Statutory Rights</H2>
      <P>
        Nothing in this policy is intended to limit any statutory rights you may have under applicable
        consumer protection law. If you are located in a jurisdiction that grants you a "cooling-off" or
        right-of-withdrawal period for digital subscriptions, those rights apply.
      </P>

      <H2>6. Payment Processing</H2>
      <P>
        All payments are securely processed by Stripe. Wanted does not store your full card details. Any
        chargebacks should first be raised with us so we can resolve the issue directly — most billing
        problems are quick fixes when we hear about them.
      </P>

      <H2>7. Changes in Price</H2>
      <P>
        We may change the price of Premium with prior notice. If a price change applies to your existing
        membership, we will let you know by email before the change takes effect, and you will have the
        opportunity to cancel before being charged the new amount.
      </P>

      <H2>8. Contact</H2>
      <P>
        For any billing or refund question, please email{" "}
        <a href="mailto:hello@joinwanted.com" className="text-gold hover:text-gold-soft">
          hello@joinwanted.com
        </a>. We aim to respond within 2 business days.
      </P>
    </LegalPageShell>
  );
}
